import { IFreemiumWidget } from 'lib/types/streamer-freemium/freemium-widget'

export const getWidget = async (streamerId: number, goalId: number | null, pollId: number | null): Promise<IFreemiumWidget> => {
  const response = await fetch(
    `${process.env.VUE_APP_FREEMIUM_API_URL}widget?streamerId=${streamerId}&goalId=${goalId}&pollId=${pollId}`,
  )
  const result = await response.json() as IFreemiumWidget
  return result
}
